// @flow
import ms from 'ms';

export const INITIALIZATION_DELAY = ms('5s');
export const SLACK_COMMUNITY_CHAT_WORKSPACE_URL = 'https://trustarcommunity.slack.com';

export const USER_STATUSES_FOR_SLACK_COMMUNITY = {
  INVITE_SENT: 'INVITE_SENT',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  USER_ALREADY_INVITED: 'USER_ALREADY_INVITED',
  USER_DISABLED: 'USER_DISABLED',
  DEFAULT: 'DEFAULT',
  ERROR: 'ERROR',
};



// WEBPACK FOOTER //
// ./src/app/modules/chat/constants.js